import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Hotel } from 'app/shared/model/hotel';
import { UtilService } from 'app/shared/util.service';
import { FollowupPropertiesService } from 'app/inter-chain/followup/properties/followup-properties.service';
import {
  canLoadData,
  getRequestParams,
  getAverageRatingQualification,
  Qualification,
} from '../followup-summary-widgets.utils';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'mh-surveys-summary-average-rating',
  templateUrl: './average-rating-widget.component.html',
  standalone: false,
})
export class AverageRatingWidgetComponent implements OnChanges {
  @Input() chainFilter: Hotel[] = [];
  @Input() productId = 1;
  @Input() currentDates: any;
  @Input() surveysReady = false;

  @Output() loadingChange = new EventEmitter<boolean>();

  loading = false;
  averageRatingPercentage = 0;
  averageRatingScore = '–/5';
  qualificationAverageRating: Qualification = 'no_data';
  heigth = '100%';

  constructor(
    private utilService: UtilService,
    private followupPropertiesService: FollowupPropertiesService,
    private router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.chainFilter || changes.currentDates || changes.surveysReady) &&
      canLoadData(this.utilService, this.chainFilter, this.surveysReady)
    ) {
      this.loadData();
    }
  }

  loadData(): void {
    this.loading = true;
    this.loadingChange.emit(true);
    const { dates, surveyIds, customerIds } = getRequestParams(this.utilService, this.chainFilter, this.currentDates);
    const surveysIdsParam = Array.isArray(surveyIds) ? surveyIds.join(',') : surveyIds;

    this.followupPropertiesService
      .getQualifications(dates, customerIds, surveysIdsParam)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.loadingChange.emit(false);
        }),
      )
      .subscribe({
        next: (response: any) => this.handleSuccess(response),
        error: () => this.handleError(),
      });
  }

  private handleSuccess(response: any): void {
    const qual = response?.average?.qualification;
    if (qual?.actual) {
      const raw = Number(qual.actual);
      const actual = Math.round(raw * 10) / 10;
      const percentage = (actual / 5) * 100;

      this.averageRatingPercentage = percentage;
      this.averageRatingScore = `${actual}/5`;
      this.qualificationAverageRating = getAverageRatingQualification(actual);
    } else {
      this.handleError();
    }
  }

  private handleError(): void {
    this.averageRatingPercentage = 0;
    this.averageRatingScore = '–/5';
    this.qualificationAverageRating = 'no_data';
  }

  onViewMore(): void {
    const isFollowup = this.productId === 1;
    const productName = isFollowup ? 'followup' : 'onsite';
    const path = isFollowup ? ['/intercadena/followup/tendencias'] : ['/intercadena/onsite/tendencias'];

    this.utilService.ga('', `interchain-${productName}-averagerating-viewtrend`);
    this.router.navigate(path, { queryParams: { trend: 'survey_total_score' } });
  }
}
